"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShieldRailgunTxid = void 0;
const merkletree_types_1 = require("../models/merkletree-types");
const bytes_1 = require("../utils/bytes");
const bitwiseMerge = (tree, index) => {
    return (tree << merkletree_types_1.TREE_DEPTH) + index;
};
/**
 * Shields don't have txids, so we generate an ID from the UTXO tree and position.
 */
const getShieldRailgunTxid = (tree, position) => {
    return (0, bytes_1.nToHex)(BigInt(bitwiseMerge(tree, position)), bytes_1.ByteLength.UINT_256);
};
exports.getShieldRailgunTxid = getShieldRailgunTxid;
